import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { lastValueFrom } from 'rxjs';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { CustomDateFormatPipe } from '../../../../../../pipes/custom-date-format.pipe';

@Component({
  selector: 'app-modal-inclusion-per-reg',
  imports: [CommonModule, CustomDateFormatPipe],
  templateUrl: './modal-inclusion-per-reg.component.html',
  styleUrl: './modal-inclusion-per-reg.component.css'
})
export class ModalInclusionPerRegComponent implements OnInit{
  @Input() regionId!: number | null;  // The ID passed from the parent
  @Input() medicineId!: number;  // The ID passed from the parent
  @Input() countryId!: number;  // The ID passed from the parent
  @Input() regionName!: string | null;  // The ID passed from the parent
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();


  isLoading = true;
  isDataEmpty = false;
  hospitalList: any[] = [];
  onekeys: any[] = [];

    constructor (private dataService: DataService) { }
ngOnInit (): void {
        document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
      
    this.loadData()

  }

  async loadData (): Promise<void> {
    if (!this.regionId) return;

    this.isLoading = true;

    try {
      const regionId = this.regionId; // to satisfy strict typing
      const infoData = await lastValueFrom(
        this.dataService.getHospitalInfoData(this.medicineId, this.countryId, regionId)
      );

      if (infoData.length > 0) {
        this.hospitalList = infoData;
        const updatedRecords = await Promise.all(
          this.hospitalList.map(async (record) => {
            const processData = await lastValueFrom(
              this.dataService.getInclusionProcessData(
                this.medicineId,
                this.countryId,
                regionId,
                record.onekey
              )
            );

            const targetStep = (processData.steps || []).find(
              (step: any) => step.openToMarket === true
            );

            const dueDate = targetStep?.dueDate || '-';
            const endDate = targetStep?.endDate || '-';
            const status = targetStep?.status === 'COMPLETED' ? 'Open' : 'Closed';

            return {
              ...record,
              dueDate,
              endDate,
              status,
            };
          })
        );

        this.hospitalList = updatedRecords;

        // Optional:
        // this.onekeys = updatedRecords.map((item: any) => item.onekey);
        // this.endDates = updatedRecords.map((item: any) => item.endDate);
      } else {
        this.isDataEmpty = true;
      }
    } catch (error) {
      console.error('Errore durante il caricamento dei dati:', error);
    } finally {
      this.isLoading = false;
    }
  }


  /*loadData(){
    if (this.regionId) {
      this.dataService.getHospitalInfoData(this.medicineId, this.countryId, this.regionId).subscribe((data: any) => {
        this.isLoading = false;

        if (data.length > 0) {
          this.hospitalList = data;
        console.log("lista ospedali: ",this.hospitalList);
        
         //  REMINDER per me stesso, questo per mappare gli onekey degli ospedali della regione e salvarli in un array di onekeys
          this.onekeys = this.hospitalList.map((item: any) => item.onekey);
        console.log("Array di onekeys: ", this.onekeys);
        } else {
          this.isLoading = false
          this.isDataEmpty = true
        }
      });
    }
}*/

  oncloseModal (value: boolean) {
    this.isLoading = false;
    this.isDataEmpty = false;
    this.hospitalList = [];
    this.closeModal.emit(value);

document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }


